<script>
  import EventFAQs from "$lib/components/EventConfirmation/EventFAQs.svelte";
  import HeroEventDetails from "$lib/components/HeroEventDetails.svelte";
  import ListThumbnail from "$lib/components/ListThumbnail.svelte";
  import LocationInformation from "$lib/components/EventConfirmation/LocationInformation.svelte";
  import Section from "$lib/components/Section.svelte";
  import SEO from "$lib/components/SEO.svelte";
  import SplitLayout from "$lib/components/SplitLayout.svelte";
  import { formatEventTime } from "$lib/utilities/eventFormatters.js";
  import { buildSrc } from "$lib/utilities/components/image-helpers";
  import { mapListItems } from "$lib/utilities/contentTypes/contentGroup";
  import { convertToEventDetailUrl, sanitizeSlug } from "$lib/utilities/url-helpers.js";

  export let data;

  let { event, recurringEvents } = data;

  const eventTime = formatEventTime(event.start, event.end);

  const eyebrowCta = event.parentProgram
    ? {
        text: event.parentProgram.title,
        url: sanitizeSlug(event.parentProgram.obamaorgPath)
      }
    : null;

  const image = event.image
    ? {
        src: event.image.file?.url,
        alt: event.image.title
      }
    : null;
  const eventLocation = event.specificLocation?.locationName ?? event.venue.name;
  const eventLocationUrl = event.venue?.obamaorgUrl;
  const locationImageSource = event.specificLocation?.mapImage ?? event.venue?.venueImage;
  const eventLocationImage = locationImageSource
    ? {
        src: buildSrc(locationImageSource),
        alt: locationImageSource.fields?.description
      }
    : null;

  const actionBar = {
    text: event.description,
    showActionItemDataOnMobile: true,
    actions: [
      {
        title: "Event Details",
        description: `${eventTime.date} • ${eventTime.time}\n${eventLocation}`,
        cta: {
          text: "Add to calendar",
          type: "textLink",
          url: "#"
        }
      },
      {
        title: "Admission",
        // REVIEW: should we handle paid events here? how we would get this info?
        description: event.registrationUrl
          ? "This event is free, just reserve your \nspot to help us get a head count."
          : "This event is free, excited to see you for this exciting event!",
        cta: event.registrationUrl
          ? {
              text: "Get Tickets",
              type: "filled",
              url: event.registrationUrl
            }
          : null
      }
    ].filter(Boolean)
  };

  const mapped = recurringEvents.map((item) => ({
    sys: { contentType: { sys: { id: "contentGroupItem" } } },
    fields: {
      headline: item.title,
      image: item.image
        ? {
            fields: {
              imageAsset: {
                fields: {
                  file: { url: item.image.file?.url },
                  alt: item.image.title
                }
              }
            }
          }
        : null,
      // body: item.summary,
      body: {
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: item.summary,
                nodeType: "text"
              }
            ],
            nodeType: "paragraph"
          },
          {
            data: {
              target: {
                sys: {
                  contentType: {
                    sys: { type: "Link", linkType: "ContentType", id: "linkComponent" }
                  }
                },
                fields: {
                  destination: {
                    fields: {
                      description: "The description of a target.",
                      internalTitle: "The Oval Office",
                      name: "The Oval Office",
                      textLinkDisplayText: "The Oval Office",
                      theme: "white",
                      url: convertToEventDetailUrl(item.slug)
                    }
                  },
                  name: "Learn More",
                  type: "smallTextLink",
                  text: "Learn More",
                  isStateChange: false
                }
              }
            },
            content: [],
            nodeType: "embedded-entry-block"
          }
        ],
        data: {},
        nodeType: "document"
      }
    }
  }));
</script>

<SEO
  data={{
    headline: event.title,
    description: event.summary
  }}
  noIndex={true}
  noFollow={true}
/>

<div class="mb-15 md:mb-20 lg:mb-25 flex flex-col gap-25">
  <HeroEventDetails
    theme={event.theme}
    title={event.title}
    {eyebrowCta}
    featuredImage={image}
    {actionBar}
  />

  {#if recurringEvents.length}
    <Section class="embedded-content">
      <SplitLayout variant="25/50">
        <div slot="leftComponent">
          <h2 class="heading-sm">More {eyebrowCta.text}</h2>
        </div>
        <div slot="rightComponent">
          <ListThumbnail data={mapListItems(mapped)} />
        </div>
      </SplitLayout>
    </Section>
  {/if}

  <Section class="embedded-content" title="Getting There">
    <LocationInformation
      locationName={eventLocation}
      locationUrl={eventLocationUrl}
      locationImage={eventLocationImage}
    />
    <EventFAQs />
  </Section>
</div>
